import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { User } from "../models/user.model";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class UserService {
  private baseUserApiUrl = environment.userManagementApiUrl;

  constructor(private http: HttpClient) {}

  getHospitalAdminUsers(): Observable<User[]> {
    return this.http
      .get<any[]>(`${this.baseUserApiUrl}/admin/users?userRole=HospitalAdmin,Provider,Coordinator`)
      .pipe(
        map((response) =>
          response
            .map((user) => this.mapUser(user))
        )
      );
  }

  createUser(user: any): Observable<any> {
    const url = `${this.baseUserApiUrl}/admin/users`;
    const postObject = {
      email: user.email,
      temporaryPassword: user.tempPassword,
      role: user.userType,
      firstName: user.firstName,
      lastName: user.lastName
    }
    return this.http.post<any>(url, postObject);
  }

  resetPassword(userId: string, tempPassword: string): Observable<any>{
    const url = `${this.baseUserApiUrl}/admin/users/${userId}/reset-password`;
    const postObject = {
      tempPassword: tempPassword
    }
    return this.http.post<any>(url, postObject);
  }

  deactivateUser(userId: string){
    const url = `${this.baseUserApiUrl}/admin/users/${userId}/deactivate`;
    return this.http.delete<any>(url);
  }

  activateUser(userId: string){
    const url = `${this.baseUserApiUrl}/admin/users/${userId}/activate`;
    const body = {};
    return this.http.put<any>(url, body);
  }



  private mapUser(user: any): User {
    const attributes = this.extractAttributes(user.Attributes);
    return {
      email: attributes["email"] || "",
      userRole: attributes["custom:user_role"] || "Unknown",
      firstName: attributes["given_name"] || "",
      lastName: attributes["family_name"] || "",
      enabled: user.Enabled,
      createdAt: user.UserCreateDate,
      lastModified: user.UserLastModifiedDate,
      status: user.UserStatus,
      donorCount: 0
    };
  }

  private extractAttributes(attributes: any[]): Record<string, string> {
    return attributes.reduce(
      (acc, attr) => {
        acc[attr.Name] = attr.Value;
        return acc;
      },
      {} as Record<string, string>
    );
  }
}
